import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { submitForm } from "../../utils/apiUtils";
import { usePermission } from "../../Auth/PermissionProvider";

const Login = () => {
 const url = process.env.REACT_APP_API_BASE_URL;
 const navigator = useNavigate();
 const { setAccessToken } = usePermission();

 const [data, setData] = useState({
  email: "",
  password: "",
 });
 const [errors, setErrors] = useState({
  email: "",
  password: "",
 });

 const [isLoading, setIsLoading] = useState(false);
 const [showPassword, setShowPassword] = useState(false);

 const handleChange = (e) => {
  const { name, value } = e.target;
  setData({ ...data, [name]: value });
  setErrors({ ...errors, [name]: "" });
 };

 const togglePassword = () => {
  setShowPassword((prev) => !prev);
 };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);

  await submitForm({
   data,
   url: `${url}api/auth/admin/login`,
   validateFields: [
    { name: "email", message: "Email is required" },
    { name: "password", message: "Password is required" },
   ],
   validationErrorsSetter: setErrors,
   onSuccess: async (response) => {
    const token = response.data.token;
    const user = response.data.payload;
    localStorage.setItem("token", token);
    localStorage.setItem("fullName", user.name);
    localStorage.setItem("email", user.email);
    localStorage.setItem("role", user.type || "");
  setAccessToken(token)
   },
   navigate: () => navigator("/dashboard"),
  });

  setIsLoading(false);
 };

 return (
  <div className="container-scroller">
   <div className="container-fluid page-body-wrapper full-page-wrapper">
    <div className="content-wrapper d-flex align-items-center auth">
     <div className="row flex-grow gx-0 ">
      <div className="col-lg-5  mx-auto ">
       <div className="auth-form-light text-left p-5">
        <div className="brand-logo text-center">
         <img src="./logo.webp" alt="Logo_img" />
        </div>
        <h4 className="text-left">Sign In to Your Kekee Impex Account</h4>
        <p className="text-left">Enter your email & password to login</p>
        <form className="pt-2" onSubmit={handleSubmit} autoComplete="on">
         <div className="form-group">
          <input
           type="email"
           className="form-control form-control-sm border border-dark   "
           id="email"
           name="email"
           placeholder="Email"
           value={data.email}
           onChange={handleChange}
           autoComplete="email"
          />
          {errors.email && <p className="text-danger">{errors.email}</p>}
         </div>
         <div className="form-group">
          <div className="password-wrapper">
           <input
            type={showPassword ? "text" : "password"}
            className="form-control form-control-sm border border-dark"
            id="password"
            name="password"
            placeholder="Password"
            value={data.password}
            onChange={handleChange}
            autoComplete="current-password"
           />

           <span className="eye-icon" onClick={togglePassword}>
            <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
           </span>
          </div>
          {errors.password && (
           <p className="text-danger mt-1">{errors.password}</p>
          )}
         </div>

         <div className="mt-3">
          <button
           type="submit"
           className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
           disabled={isLoading}
          >
           {isLoading ? (
            <>
             <i className="fa fa-spinner fa-spin mr-2"></i> Logging in...
            </>
           ) : (
            "Login"
           )}
          </button>
         </div>
         <div className="d-flex justify-content-end mt-4">
         <Link
          to="/forgot-password"
          className="text-decoration-none text-dark"
         >
          <span>Forgot Password?</span>
          {/* <i className="fa-solid fa-arrow-up-right-from-square ml-2"></i> */}
         </Link>

         </div>
        </form>
       </div>
      </div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default Login;
